import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment.development";
import { TramiteExclusionRes } from "./interface/TramiteExclusionRes";
import { TramiteSolicitudesRes } from "./interface/TramiteSolicitudesRes";
import { TramiteEstadoReq } from "./interface/TramiteEstadoReq";

let apiVucUrl = environment.apiVucUrl;

@Injectable({
    providedIn: 'root'
})

export class TramiteExclusionService {
    constructor(private http: HttpClient){}

    mostrarExclusionSolicitud(idSolicitud: number): Observable<TramiteExclusionRes[]>{
        return this.http.get<TramiteExclusionRes[]>(apiVucUrl + `api/v1.0/tramites-exclusion/${idSolicitud}`);
    }

    mostrarExclusionSolicitudYFase(idSolicitud: number, idFase: number): Observable<TramiteExclusionRes[]>{
        return this.http.get<TramiteExclusionRes[]>(apiVucUrl + `api/v1.0/tramites-exclusion/${idSolicitud}/${idFase}`);
    }

    cambiarEstadoTramiteExclusion(body: TramiteEstadoReq): Observable<any>{
        return this.http.put(apiVucUrl + `api/v1.0/tramites-exclusion/estado`, body);
    }

    mostrarSolicitudesTramitesExpediente(): Observable<TramiteSolicitudesRes[]>{
        return this.http.get<TramiteSolicitudesRes[]>(apiVucUrl + `api/v1.0/tramites-exclusion/solicitudes`);
    }

}
